import { AuthorisationService } from 'src/app/services/auth/authorisation.service';
import { Functionalities } from 'src/app/services/auth/functionalities';

export class PlanningOverviewViewModel {
    openEntity = false;
    addPlanning = false;
    addPlanningFixed = false;
    lockPlanning = false;

    updateViewState() {
        this.openEntity = AuthorisationService.hasFunctionality(Functionalities.EntitiesManagement);
        this.addPlanning = AuthorisationService.hasAnyFunctionality([
            Functionalities.PlanningOverviewOwn,
            Functionalities.PlanningOverviewManagement,
        ]);
        this.addPlanningFixed = AuthorisationService.hasFunctionality(Functionalities.TransportplanningManagement);
        this.lockPlanning = AuthorisationService.hasFunctionality(Functionalities.TransportplanningManagement);
    }
}
